import { UnresolvedObj } from "../types";

type CreateFileObjectArgs = Omit<UnresolvedObj, "sprite">;

const sprite = {
  w: 8,
  h: 10,
  c: [
    1, 1, 1, 1, 1, 0, 0, 0,
    1, 0, 0, 0, 1, 1, 0, 0,
    1, 0, 0, 0, 1, 0, 1, 0,
    1, 0, 0, 0, 1, 1, 1, 1,
    1, 0, 0, 0, 0, 0, 0, 1,
    1, 0, 0, 0, 0, 0, 0, 1,
    1, 0, 0, 0, 0, 0, 0, 1,
    1, 0, 0, 0, 0, 0, 0, 1,
    1, 0, 0, 0, 0, 0, 0, 1,
    1, 1, 1, 1, 1, 1, 1, 1,
  ],
};

export const createFileObject = (args: CreateFileObjectArgs) => {
  return {
    ...args,
    sprite,
    z: 0, // TODO create parent/inheritance function to set defaults
    w: sprite.w,
    h: sprite.h,
  };
}
